module.exports = __webpack_public_path__ + "img/ab-test.6c5bba94.png";